import _upperFirst from 'lodash/upperFirst'
import _camelCase from 'lodash/camelCase'

export function getStatusAction(status) {
  switch (status) {
    case 'deleted':
      return 'delete'
    case 'rejected':
      return 'reject'
    case 'declined':
      return 'decline'
    case 'cancelled':
      return 'cancel'
  }
}

export function contains(text, value){
  if (typeof text !== 'string' || typeof value !== 'string' ){
    console.info('Non-String type attempted use of string contains')
    return false
  }
  var re = new RegExp(value);
  return re.test(text);
}

export function pascalCase(text){
  if (typeof text !== 'string'){
    console.info('Non-String type attempted use of string pascalCase')
  }
  return _upperFirst(_camelCase(text))
}